module.exports = __webpack_public_path__ + "static/media/variants-choice2.6c162bcc.png";